<template>
    <v-card elevation="2" shaped class="ma-1">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Paramètres du module PDF </v-toolbar-title>
      </v-toolbar>


      <div v-if="!displays.params.root">
      <v-row >
        <v-col>
          {{ typegenerate }}
          <Select
              :item="{name: 'Comment souhaitez-vous créer le document ?',value: 'type',liste: [{ text: 'Générer le document', value: 'generate' },{ text: 'mentionner le chemin du fichier', value: 'manual' }],
              defaultprops:{ show: true, column: false }}"
              :change="(item,value,select) => { typegenerate = value[select]; type }"
              :valField="typegenerate"
            />  
            <TextField
            v-if="typegenerate=='manual'"
            :item="{ name: 'Chemin du fichier', value: 'root' ,defaultprops:{ show: true }}"
            :valField="manual"
            :keyup="(item,model)=> { manual = model; displays.params.root =model;  }"
            /> 

            <v-btn @click="generate" :disabled="!typegenerate || (typegenerate=='manual' && manual=='')">
              Appliquer
            </v-btn>
        </v-col>
      </v-row>
    </div>

      <div v-else>


        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Paramètres généraux </v-tab>
          <v-tab> requetes </v-tab>
          <v-tab> Champs </v-tab>
          <v-tab> Autres requetes</v-tab>
          <v-tab> Stockage </v-tab>
          <v-tab> FacturX </v-tab>

          <v-tabs-items v-model="tab" class="pl-4">

            <v-tab-item>
              <v-row>
                <v-col class="ma-1">
                  <TextField
                    :item="{ name: 'chemin du document', value: 'root' ,defaultprops:{ show: true }}"
                    :valField="displays.params.root"
                    :keyup="(item,model,selectedKey)=> { displays.params.root = model; $emit('recepVal',displays); }"
                    /> 
                    <p>Vous pouvez utiliser la variable [[pdf||mon_as]] pour personnaliser le nom (ne pas mettre l'extension .pdf)</p>
                    <TextField
                    :item="{ name: 'Nom du document', value: 'documentname' ,defaultprops:{ show: true }}"
                    :valField="displays.params.documentname"
                    :keyup="(item,model,selectedKey)=> { displays.params.documentname = model; $emit('recepVal',displays); }"
                    /> 
                    <SwitchC
                    :item="{name: 'Afficher le bouton de téléchargement',value: 'download',
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,model,selectedKey)=> { displays.params.download = model; $emit('recepVal',displays); }"
                    :valField="displays.params.download"
                    /> 
                    <v-divider class="my-4" />
                    <v-switch
                      v-model="displays.params.translation.enabled"
                      label="Activer le choix de la langue"
                      color="primary"
                      persistent-hint
                      hint="Affiche un sélecteur de langue à côté du téléchargement du PDF."
                      @change="translationChanged"
                    />
                    <v-select
                      v-if="displays.params.translation.enabled"
                      v-model="displays.params.translation.default"
                      :items="displays.params.translation.locales"
                      item-text="text"
                      item-value="value"
                      label="Langue par défaut"
                      outlined
                      dense
                      @change="translationChanged"
                    />
                    <TextField
                    :item="{ name: 'height', value: 'height' ,defaultprops:{ show: true }}"
                    :valField="displays.params.iframe.height"
                    :keyup="(item,model)=> { displays.params.iframe.height = model; $emit('recepVal',displays); }"
                    /> 
                    <TextField
                    :item="{ name: 'width', value: 'width' ,defaultprops:{ show: true }}"
                    :valField="displays.params.iframe.width"
                    :keyup="(item,model)=> { displays.params.iframe.width = model; $emit('recepVal',displays); }"
                    /> 
                    <Select
                    :item="{name: 'Orientation',value: 'orientation',liste: [{ text: 'paysage', value: 'landscape' },{ text: 'portrait', value: 'table' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="(item,value) => { displays.params.orientation = value.value; $emit('recepVal',displays); }"
                    :valField="displays.params.orientation"
                    />
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <Filtre
                :filtre="displays.filter"
                :table="module.table"
                @recepVal="changeFilter"
              />
            </v-tab-item>

          <v-tab-item>
            <Fields
              :table="module.table"
              :champs="displays.params.champs"
              :filter="displays.filter"
              :modalKey="modalKey"
              :page="page"
              @recepVal="changeEC"
              />
          </v-tab-item>



          <v-tab-item>

          <v-btn fab small @click="addListe"><v-icon>mdi-plus</v-icon></v-btn>
          <v-expansion-panels variant="popout" v-model="listQuerysAccordion" class="pa-3">
          <v-expansion-panel v-for="(query, i) in displays.params.querys" :key="'lf'+i" v-show="query.key!='default'">
            <v-expansion-panel-header>
              {{query.key}}
              <template v-slot:actions>
                <v-btn icon @click="removeListe(i)" v-if="query.key!='default'"><v-icon>mdi-close-thick</v-icon></v-btn>
              </template> 
            </v-expansion-panel-header>

            <v-expansion-panel-content class="grey lighten-3">

              <div>
                <TextField                  
                :item="{name:'clé',value:'key',defaultprops:{show:true}}" 
                :keyup="(item,value) => {query.key = value } "
                :valField="query.key"/>
                <Select
                  :item="{name: 'table ciblée',value: 'table',liste: listTables,
                  defaultprops:{ show: true,clearable:true } } "
                  :change="(item,value) => { query.table = value['value'] || ''; } "
                  :valField="query.table"
                  />               
              </div>

              <v-tabs v-model="tabsFiche" v-if="query.table && query.table!=''">
                <v-tab> Filtre </v-tab>
                <v-tab> Champs </v-tab>
                <v-tabs-items v-model="tabsFiche">
                  <v-tab-item>
                    <Filtre :page="page" :filtre="query.filtre" :table="query.table" />
                  </v-tab-item>
                  <v-tab-item> 
                    <Fields :page="page" :champs="query.champs" :modalKey="modalKey" :filter="query.filtre" :table="query.table" />
                    </v-tab-item>
                </v-tabs-items>
              </v-tabs>

            </v-expansion-panel-content>  

          </v-expansion-panel>
          </v-expansion-panels>

          </v-tab-item>







          <v-tab-item>
            Vous pouvez stocker le PDF une fois celui-ci généré.
            <Select
              :item="{name: 'Configuration de stockage',value: 'type',liste: [{ text: 'pas de stockage', value: '' },{ text: 'dans une table', value: 'table' },{ text: 'dans la GED', value: 'ged' }],
              defaultprops:{ show: true, column: false }}"
              :change="(item,value,select) => { displays.params.storage.type = value[select]; $emit('recepVal',displays); }"
              :valField="displays.params.storage.type"
            /> 

            <div v-if="displays.params.storage.type=='ged' && listGedModule.length">
             Pour stocker le document dans la GED, vous devez créer un module GED pour les paramétrages.
             <Select
              :item="{name: 'Choix du module GED',value: 'type',liste: listGedModule,
              defaultprops:{ show: true, column: false }}"
              :change="(item,value) => {displays.params.storage.ged.module = value['value']; $emit('recepVal',displays);}"
              :valField="displays.params.storage.ged.module"
            /> 
              Param à faire passer pour ouvrir la GED
            <ArrayTable 
              :item="{otherparams:{
                  arrayTable:[
                      {type:'',key:'name',name:'nom du paramètre'},
                      {type:'',key:'value',name:'valeur du paramètre',description:'Vous pouvez insérer la variable d\'envirronnement [[line||mon_as]]'}]}
              ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'Ajouter un paramètre pour l\'utilisation de la GED'}}"
              :valField="displays.params.storage.ged.params"
              :change="(item,value) => {displays.params.storage.ged.params = value; $emit('recepVal',displays);}"
              />
              <!--
            <Select
            v-if="displays.params.storage.ged.module!='' && gedFolder().length!=0"
              :item="{name: 'Dossier',value: 'folder',liste: gedFolder(),
              defaultprops:{ show: true, itemtext:'name',description:'La sélection est facultative' }}"
              :change="(item,value) => {displays.params.storage.ged.folder = value['name']; $emit('recepVal',displays);}"
              :valField="displays.params.storage.ged.module"
            /> -->

            </div>
            <div v-if="displays.params.storage.type=='table'">
              Sélectionnez la table qui va faire l'objet de l'entrée
              <Select
              :item="{name: 'Table',value: 'type',liste: listTables,
              defaultprops:{ show: true, column: false }}"
              :change="tableStockage"
              :valField="displays.params.storage.params.table"
            /> 

              <div v-for="(field, i) in fieldsTableStockage" :key="i">
                <TextField
                  :item="{ name: field.table+' '+field.name, value: 'width' ,defaultprops:{ show: true }}"
                  :valField="displays.params.iframe.width"
                  :keyup="(item,model)=> { displays.params.iframe.width = model; }"
                  /> 
              </div>
            </div>

          </v-tab-item>

          <v-tab-item>
            Vous pouvez lier un module XML UBL pour créer une facturX :
      
             <Select
              :item="{name: 'Choix du module XML',value: 'type',liste: listXMLModule,
              defaultprops:{ show: true, column: false,clearable : true }}"
              :change="(item,value) => {displays.params.facturx.module = value?.value ?? ''; }"
              :valField="displays.params.facturx.module"
            />
              Param à faire passer pour l'XML
            <ArrayTable 
              :item="{otherparams:{
                  arrayTable:[
                      {type:'',key:'name',name:'nom du paramètre'},
                      {type:'',key:'value',name:'valeur du paramètre',description:'Vous pouvez insérer la variable d\'envirronnement [[line||mon_as]]'}]}
              ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'Ajout'}}"
              :valField="displays.params.facturx.params"
              :change="(item,value) => {displays.params.facturx.params = value;}"
              />
          </v-tab-item>

          </v-tabs-items>
        </v-tabs>
    </div>
    </v-card>
  </template>
  
  
  
  <script>
    import { admin } from '../mixins'; 
  export default {
    name: "PdfModule",

    mixins : [admin],

  
    data: function () {
      return {

        displays: this.module.displays,
        listQuerysAccordion : '',
        tabsFiche : '',
        typegenerate : '',
        manual : '',
        tab : null,
        listTables : [],
        fieldsTableStockage : [],
        listGedModule : [],
        listXMLModule : [],
      };
    },
  
    watch: {

    },
  
    methods: {

      ensureTranslationParams() {
        const defaultLocales = [
          { text: 'Français', value: 'fr' },
          { text: 'Anglais', value: 'en' },
          { text: 'Espagnol', value: 'es' },
          { text: 'Allemand', value: 'de' },
          { text: 'Italien', value: 'it' },
          { text: 'Chinois simplifié', value: 'zh-CN' },
        ]

        if (!this.displays.params.translation || Array.isArray(this.displays.params.translation)) {
          this.$set(this.displays.params, 'translation', {
            enabled: false,
            default: 'fr',
            locales: defaultLocales,
          })
          return
        }

        const translation = this.displays.params.translation
        if (typeof translation.enabled !== 'boolean') this.$set(translation, 'enabled', false)
        if (!translation.default) this.$set(translation, 'default', 'fr')
        if (!Array.isArray(translation.locales) || translation.locales.length === 0) {
          this.$set(translation, 'locales', defaultLocales)
        } else {
          defaultLocales.forEach(locale => {
            if (!translation.locales.some(current => current.value === locale.value)) {
              translation.locales.push(locale)
            }
          })
        }
      },

      translationChanged() {
        const translation = this.displays.params.translation
        const localeExists = translation.locales.some(locale => locale.value === translation.default)
        if (!localeExists) translation.default = translation.locales[0]?.value || 'fr'
        this.$emit('recepVal', this.displays)
      },

      generate() {
        this.API({type:'post', url:'pdf/generatefile', params:{id:this.module.id, type:this.typegenerate,manual : this.manual}}).then((resp) => {
          if(resp.data.success) {
            this.$toast.success('génération effectuée')
          } else {
            this.$toast.error(resp.data.message)
          }
        })
      },

      changeFilter(array) {
      this.displays.filter = array
      this.$emit('recepVal',this.displays)
    },

    changeEC(array) {
      this.displays.params.champs = array
      this.$emit('recepVal',this.displays)     
    },

      tableStockage(iem,value,selectedKey) {

        this.displays.params.storage.params.table = value[selectedKey]; 
        
        this.getListField({filter:{table:value[selectedKey]}}).then((resp) => {
          this.fieldsTableStockage = resp       
        })
        this.$emit('recepVal',this.displays);
      },

      // ne serv pas encore mais c'est pour choisir le dossier (créé automatiquement sur 1ere ouverture de GED) ou le pdf va etre stocké
      gedFolder() {

        return this.listGedModule.find( el => el.value == this.displays.params.storage.ged.module).listfolder
      },


      addListe() {
    
    var defaultEncart = this.displays.params.querys.find((el) => el.key ==='default')
    let copieDefault = JSON.parse(JSON.stringify(defaultEncart))
    copieDefault.name="nouvelle liste"
    copieDefault.key="newliste"
    this.displays.params.querys.push(copieDefault);
  },

  removeListe(index) {
    this.displays.params.querys = this.displays.params.querys.filter((el,i)=> i!=index);
  }
  
    },
  
    created() {
        this.ensureTranslationParams()
    },

    mounted() {
        //récupère toutes les tables pour le choix du champ pour la liste déroulante au dessus du calendrier
        this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
            resp.data.forEach((table) => {
                this.listTables.push({text:table,value:table})
            })
            
        })

        this.API({type:'post', url:'/engine/module/list',params:{type:['ged','facturexml']}}).then((resp) => {                                             
                       resp.data.forEach((ged) => {
                        if(ged.type == 'ged') this.listGedModule.push({text:ged.name,value:ged.id,listfolder:ged.displays.params.foldersonopen});
                        if(ged.type == 'facturexml') this.listXMLModule.push({text:ged.name,value:ged.id});
                       })
               })
    },
  };
  </script>
